import React from 'react';
import { Link } from 'react-router-dom';
import './HomeBlocks.css';
import { bannerHref, blockTextStyle, isInternalHref } from '../../utils/homeLayout';

/**
 * Full-width promo block: an image, video or flat colour behind a heading, some
 * copy and an optional button. Used by the Home page block layout.
 */
function BannerBlock({ section }) {
  const href = bannerHref(section);
  const showButton = !!href && !!section.buttonText;
  // A banner can legitimately be just an image, so an empty text layer is fine -
  // but then it should not reserve any space either.
  const hasContent = !!section.heading || !!section.body || showButton;

  const button = showButton && (
    isInternalHref(href)
      ? <Link className="home-banner-button" to={href}>{section.buttonText}</Link>
      : <a className="home-banner-button" href={href} target="_blank" rel="noopener noreferrer">{section.buttonText}</a>
  );

  return (
    <section
      className={`home-banner home-banner-${section.height || 'medium'} home-banner-${section.align || 'left'}`}
      style={blockTextStyle(section)}
    >
      <div className="home-banner-media">
        {section.mediaType === 'video' && section.mediaUrl && (
          <video src={section.mediaUrl} muted loop autoPlay playsInline preload="metadata" />
        )}
        {section.mediaType === 'image' && section.mediaUrl && (
          <img src={section.mediaUrl} alt="" />
        )}
        {(section.mediaType === 'color' || !section.mediaUrl) && (
          <div
            className="home-banner-color"
            style={{ backgroundColor: section.backgroundColor || '#141414' }}
          />
        )}
      </div>

      <div
        className="home-banner-overlay"
        style={{ opacity: typeof section.overlay === 'number' ? section.overlay : 0.4 }}
      />

      {hasContent && (
        <div className="home-banner-content">
          {section.heading && <h2 className="home-banner-heading">{section.heading}</h2>}
          {section.body && <p className="home-banner-body">{section.body}</p>}
          {button}
        </div>
      )}
    </section>
  );
}

export default BannerBlock;
